exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-headers__title[data-v-27901d94]{font-size:1em;font-weight:600}.file-headers__subtitle[data-v-27901d94]{font-size:.8em;color:#444;text-transform:uppercase}.file-detail-header[data-v-27901d94]{border-top:1px solid #dee2e6;border-bottom:1px solid #dee2e6}.file-controls[data-v-27901d94]{border-bottom:1px solid #dee2e6}.file-detail-download[data-v-27901d94]{transition:height .25s ease;position:relative}.file-detail-download__progress[data-v-27901d94]{transition:width .15s ease;min-width:30px;width:73%;position:relative}.file-detail-download__text[data-v-27901d94]{position:absolute;left:0;top:0;height:100%;padding:.5em;font-size:1em;color:#fff;text-transform:uppercase}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-27901d94","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/received-files-view/received-files-file.vue
// module id = 124
// module chunks = 0